var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgView(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 26,
    width: 26,
    viewBox: "0 0 40 40",
    fill: "currentColor",
    className: "text-samurai-gray-300 dark:text-samurai-gray-100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 26.375q3 0 5.104-2.104t2.104-5.104q0-3-2.104-5.104Q23 11.958 20 11.958t-5.104 2.105q-2.104 2.104-2.104 5.104t2.104 5.104Q17 26.375 20 26.375Zm0-2.583q-1.917 0-3.271-1.354-1.354-1.355-1.354-3.271 0-1.917 1.354-3.271 1.354-1.354 3.271-1.354 1.917 0 3.271 1.354 1.354 1.354 1.354 3.271 0 1.916-1.354 3.271-1.354 1.354-3.271 1.354Zm0 7.875q-6.083 0-11.021-3.438-4.937-3.437-7.312-9.062 2.375-5.625 7.312-9.063Q13.917 6.667 20 6.667q6.083 0 11.021 3.437 4.937 3.438 7.312 9.063-2.375 5.625-7.312 9.062Q26.083 31.667 20 31.667Zm0-12.5Zm0 9.708q4.917 0 9.062-2.646 4.146-2.646 6.313-7.062-2.167-4.417-6.292-7.063T20 9.458q-4.917 0-9.062 2.646-4.146 2.646-6.313 7.063 2.167 4.416 6.292 7.062T20 28.875Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.4b38b47d175a7cc96d1ec1049c377770.svg";
export { ForwardRef as ReactComponent };